import { memo } from "react"
import Tag from "./tag"

interface AmountTagProps {
    amount: number
    unit?: string
    lowStockWarning?: number
    text?: string
    isLoading?: boolean
    size?: 'sm' | 'lg'
}

const AmountTag: React.FC<AmountTagProps> = ({ amount, unit, lowStockWarning = 0, text = ``, isLoading, size }) => {
    const warningLimit = Number.isFinite(lowStockWarning) ? lowStockWarning : 0
    const colorScheme =
        Number.isNaN(amount) ? `gray` :
        amount > warningLimit && amount > 0 ? `green` :
        `red`

    return <Tag colorScheme={colorScheme} size={size} isLoading={isLoading || Number.isNaN(amount)}>{Number.isNaN(amount) ? `` : <>{text}{text.length ? `: ` : ``}{amount} {unit}</>}</Tag>
}

export default memo(AmountTag)
